import { TXTWCL_Consecutive_hyphens_are_not_al_ELL } from '../translations';
import type { Error } from '../types';
import { NO_CONSECUTIVE_HYPHENS } from '../utils/regex';

export const noConsecutiveHyphens = (value: string): Error => ({
  valid: !NO_CONSECUTIVE_HYPHENS.test(value),
  message: TXTWCL_Consecutive_hyphens_are_not_al_ELL
});
